import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doctorActions, patientActions, ehrActions } from "../core/actions";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CASERECORD } from "../shared/constants";
import { format } from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { helperServices } from "../shared/helper";
import PrintIcon from "@mui/icons-material/Print";

// ── Print helper: opens a new window with only that section's content ─────────
const printSection = (sectionId, title) => {
  const content = document.getElementById(sectionId);
  if (!content) return;
  const printWindow = window.open("", "_blank", "width=900,height=700");
  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 24px; font-size: 13px; }
          h2 { text-align: center; border-bottom: 2px solid #333; padding-bottom: 8px; margin-bottom: 16px; }
          .print-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 24px; }
          .print-field { margin-bottom: 10px; }
          .print-label { font-weight: bold; font-size: 11px; color: #444; margin-bottom: 2px; }
          .print-value { border-bottom: 1px solid #999; min-height: 20px; padding: 2px 4px; font-size: 13px; white-space: pre-wrap; }
          .print-full { grid-column: 1 / -1; }
          .print-section-title { font-weight: bold; font-size: 12px; background: #f0f0f0;
            padding: 4px 8px; margin: 12px 0 6px; border-left: 4px solid #555; grid-column: 1 / -1; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 12px; }
          table td { border: 1px solid #bbb; padding: 5px 8px; font-size: 12px; }
          @media print { body { padding: 10px; } }
        </style>
      </head>
      <body>
        <h2>${title}</h2>
        ${content.innerHTML}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => { printWindow.print(); printWindow.close(); }, 400);
};

function VedamaayuNotes(props) {
  const dispatch = useDispatch();
  const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
  const inputRefs = useRef([]);
  const [status, setStatus] = useState(undefined);
  const [todayDate, setTodayDate] = useState(new Date());
  const [revisitDate, setRevisitDate] = useState(
    format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
  );
  const [diagnosistemplate, setDiagnosistemplate] = useState();
  const [followUpdateFlag, setFollowUpdateFlag] = useState(true);
  const [patientDetail, setPatientDetail] = useState({
    patientId: "",
    lastvisitId: "",
    scheduleddate: "",
  });

  // ── ONE notes object — same pattern as original ───────────────────────────
  // Every key becomes a claSS value saved to DB via addCaseRecord.
  // Original keys "Comment" and "Follow Up Date For Vedamaayu" are unchanged.
  const [notes, setNotes] = useState({
    // ── original keys (unchanged) ──
    "Comment": "",
    "Follow Up Date For Vedamaayu": "",
    // ── Doctor section ──
    "Chief Complaint": "",
    "Present History": "",
    "Past History": "",
    "Personal History": "",
    "Appetite": "",
    "Micturition": "",
    "Bowel": "",
    "Sleep": "",
    "Family History": "",
    "General Systemic Examination": "",
    "Allergies Adverse Reaction": "",
    "Allergies Adverse Reaction Details": "",
    "Vulnerable Patient Doctor": "",
    "Lab Investigation": "",
    "Treatment History": "",
    "Diagnosis": "",
    "Doctor Temp": "",
    "Doctor BP": "",
    "Doctor Pulse": "",
    "Doctor Height": "",
    "Doctor Weight": "",
    // ── Nurse vitals ──
    "BP": "",
    "Temperature": "",
    "Pulse": "",
    "Respiratory Rate": "",
    "Saturation": "",
    "Height": "",
    "Weight": "",
    "GRBS": "",
    // ── Nurse section ──
    "Level of Consciousness": "",
    "Respiratory Status": "",
    "Nurse Chief Complaint": "",
    "Skin Integrity": "",
    "Current Medications": "",
    "Investigation Ordered": "",
    "Diet": "",
    "Vulnerable Nurse": "",
    "Special Care": "",
    "Pain Score": "",
    "Pressure Sores": "",
    "Pressure Sores Description": "",
    "Restraints Used": "",
    "Restraint Description": "",
  });

  const [showError, setShowError] = useState(false);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [loadsummary, setLoadSummary] = useState(false);
  const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
  const [formErrors, setFormErrors] = useState({
    "Comment": "",
  });
  const [filterdProList, setfilterdProList] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState("");

  const useStyles = makeStyles((theme) => ({
    redAsterisk: { color: "red" },
  }));
  const classes = useStyles();

  useEffect(() => {
    console.log("props data is : ", props);
    let patientId = props.patientData.id;
    let visitId = props.patientData.visit.id;
    dispatch(
      patientActions.getrevisitbyId(patientId, visitId, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          patientDetail["scheduleddate"] = resCb.scheduleddate;
          if (
            patientDetail["scheduleddate"] !== " " &&
            patientDetail["scheduleddate"] !== undefined &&
            patientDetail["scheduleddate"] !== null
          ) {
            setRevisitDate(
              format(new Date(patientDetail["scheduleddate"]), "yyyy-MM-dd")
            );
          } else {
            setRevisitDate(
              format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
            );
          }
        }
      })
    );
    getNotesDetails();
    getDiagnosistemplateById();
  }, []);

  // ── Identical logic to original getNotesDetails ───────────────────────────
  const getNotesDetails = () => {
    props.patientData.patientId = props.patientData.id;
    props.patientData.visitId = props.patientData.visit.id;
    props.patientData.groupname = CASERECORD;
    console.log("details :: ", props.patientData);
    dispatch(
      patientActions.getDischargeSummary(notes, props.patientData, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          if (resCb.procedureList) {
            const filterList = resCb.procedureList.filter(
              (items) => items.groupname === CASERECORD
            );
            const keys = Object.keys(notes);
            var patientNotes = { ...notes };
            var filteredProList = [];
            filterList.forEach((item) => {
              for (let key of keys) {
                if (item.claSS == key) {
                  patientNotes[key] = item.notes;
                  filteredProList.push(item);
                  setNotes({ ...patientNotes });
                }
              }
              setfilterdProList([...filteredProList]);
            });
          }
          if (resCb && resCb.vaList && resCb.vaList[0]) {
            console.log("resCb.vaList[0]", resCb.vaList[0].targetid);
            getDoctorsList(resCb.vaList[0].targetid);
          }
        }
      })
    );
  };

  const closeServiceModal = (event) => {
    props.onModalClose(event);
  };

  const saveDiagnosisinEHR = (finaldiagnosis) => {
    let templateId = "Diagnosis";
    let patientId = props.patientData.id;
    let visitId = props.patientData.visit.id;
    console.log("Templateiddddd", diagnosistemplate.content[0].data);
    diagnosistemplate.content[0].subject.name = selectedDoctor;
    for (let item of diagnosistemplate.content[0].data.items) {
      let element = item.name.value;
      const time = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      ).toISOString();
      switch (element) {
        case "Problem/Diagnosis name": item.value.value = "Diagnosis"; break;
        case "Clinical description": item.value.value = finaldiagnosis.notes; break;
        case "Date/time of onset": item.value.value = time; break;
        case "Date/time of resolution": item.value.value = time; break;
        case "Date/time clinically recognised": item.value.value = time; break;
        default:
      }
    }
    let notesDetails = finaldiagnosis.notes ? finaldiagnosis.notes : "NA";
    let procedure = props.selectedProcedure ?? null;
    dispatch(
      ehrActions.saveComposition(
        diagnosistemplate, patientId, visitId, templateId,
        patientEhrid, notesDetails, procedure,
        (resCb) => {
          if (resCb) {
            if (resCb.successMessages) {
              props.onModalClose({ success: resCb.successMessages[0] });
            } else {
              if (resCb.errorMessages[0]) {
                props.onModalClose({ error: resCb.errorMessages[0] });
              }
            }
          }
        }
      )
    );
  };

  const getDiagnosistemplateById = () => {
    let templateId = "Diagnosis";
    dispatch(
      ehrActions.getTemplateById("", templateId, {}, (resCb) => {
        if (resCb) {
          console.log("Getdiagnosiss rescb", resCb);
          setDiagnosistemplate(resCb);
        }
      })
    );
    return diagnosistemplate;
  };

  // ── Identical to original handleInputChange ───────────────────────────────
  const handleInputChange = (name, value) => {
    setShowError(false);
    console.log("In handleinput change", name, value);
    let updatedFormErrors = { ...formErrors };
    if (name === "Comment" && value.length > 800) {
      updatedFormErrors[name] = name + " exceeds limit of 800 characters";
    } else {
      updatedFormErrors[name] = "";
    }
    setFormErrors(updatedFormErrors);
    formErrors[name] = "";
    var patientNotes = notes;
    var keyList = [];
    patientNotes[name] = value;

    if (filterdProList && filterdProList.length > 0) {
      filterdProList.forEach((item) => {
        if (item.claSS == name) {
          keyList.push({
            claSS: item.claSS,
            notes: value,
            id: item.id,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        }
        setfilterdProList([...keyList]);
      });
    }
    setNotes({ ...patientNotes });
  };

  const handleSubmit = (e) => {
    validateForm(e);
    setTimeout(() => {
      console.log("props:", props);
    }, 3000);
  };

  const setMessageStrip = (e) => {
    console.log("message obtained", e);
    var ServerResVal = ServerRes;
    if (e.success) {
      ServerResVal.success = e.success;
    } else {
      ServerResVal.error = e.error;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => { closeAlert(); }, 5000);
  };

  const UpdateRevisitDetails = () => {
    console.log(" insert  props", props);
    patientDetail.patientId = props.patientData.id;
    patientDetail.lastvisitId = props.patientData.visit.id;
    console.log("patientdetail.....", patientDetail, revisitDate);
    let date = format(new Date(revisitDate), "dd-MM-yyyy");
    notes["Follow Up Date For Vedamaayu"] = date;
    patientDetail.scheduleddate = date;
    setFollowUpdateFlag(date);
    console.log("notes adte:", notes["Follow Up Date For Vedamaayu"]);
    return patientDetail;
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  // ── Identical to original validateForm ────────────────────────────────────
  const validateForm = (e) => {
    console.log("Submit Notes:", e);
    console.log("formErrors : ", formErrors);
    for (let key in formErrors) {
      if (formErrors[key] !== "") {
        setMessageStrip({ error: "Please check there is a validation error in the notes form" });
        return;
      }
    }
    setShowError(false);
    var ServerResVal = ServerRes;
    e.preventDefault();
    var proList = [];
    let finaldiagnosis = {};
    const followUpDetails = UpdateRevisitDetails();
    const keys = Object.keys(notes);

    if (filterdProList && filterdProList.length > 0) {
      filterdProList.forEach((item) => {
        if (item.claSS === "Follow Up Date For Vedamaayu") {
          proList.push({
            id: item.id,
            claSS: item.claSS,
            notes: followUpDetails.scheduleddate,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        } else {
          proList.push({
            id: item.id,
            claSS: item.claSS,
            notes: item.notes,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        }
      });
      console.log("proList in edit case: ", proList);
    } else {
      for (let key of keys) {
        proList.push({
          claSS: key,
          notes: notes[key],
          patientId: props.patientData.id,
          visitId: props.patientData.visit.id,
        });
        console.log("proList in add case: ", proList);
      }
    }
    notes["notes"] = "NOTE";

    dispatch(
      doctorActions.addCaseRecord(proList, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          if (resCb.successMessages) {
            if (
              finaldiagnosis &&
              finaldiagnosis.notes !== "" &&
              finaldiagnosis.notes !== undefined
            ) {
              saveDiagnosisinEHR(finaldiagnosis);
            }
            props.onModalClose({ success: "Notes added successfully" });
          } else {
            props.onModalClose({ error: "Failed to add notes" });
          }
          console.log("resCbe : ", resCb);
        }
      })
    );
    setMessageStrip({ success: e.successMessages });
    setServerRes({ ...ServerResVal });
    setTimeout(() => { closeAlert(); }, 3000);
  };

  const ChangeRevisitDate = (event) => {
    console.log("date: ", event.target.value);
    setRevisitDate(event.target.value);
  };

  const getDoctorsList = (targetid, data) => {
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          let list = [];
          console.log("rescb from getdoctorlist: ", resCb);
          for (let doc of resCb) {
            if (doc != null) {
              let opt = {};
              if (!doc.first_name) doc.first_name = "";
              if (!doc.last_name) doc.last_name = "";
              if (doc && doc.gvId) {
                opt["id"] = doc.personId;
                opt["gvid"] = doc.gvId;
              }
              const name = helperServices.getFullName(doc.first_name, null, doc.last_name);
              opt["role"] = doc.role;
              opt["type"] = doc.type;
              opt["value"] = doc.email;
              opt["department"] = doc.department;
              opt["firstName"] = doc.first_name;
              opt["lastName"] = doc.last_name;
              opt["departmentId"] = doc.departmentId;
              opt["label"] =
                doc.displaytitle + "." + " " + name + ", " +
                "Dep of " + doc.department + " (" + doc.qualification + " )";
              list.push(opt);
              if (targetid && targetid == doc.personId) {
                setSelectedDoctor(doc.displaytitle + ". " + name);
              }
            }
          }
        }
      })
    );
  };

  // ── Patient info for print headers ────────────────────────────────────────
  const patientName = props.patientData?.patientName || props.patientData?.name || "";
  const patientAge  = props.patientData?.age || "";
  const patientSex  = props.patientData?.sex || props.patientData?.gender || "";
  const uhid        = props.patientData?.uhid || props.patientData?.id || "";
  const ipNo        = props.patientData?.visit?.ipopnumber || props.patientData?.ipopnumber || "";
  const visitType   = props.patientData?.visit?.type || props.patientData?.visitType || "";
  const ipOpLabel   = /^OP/i.test(ipNo) || /outpatient/i.test(visitType) ? "OP No." : "IP No.";
  const ward        = props.patientData?.ward || "";
  const todayStr    = format(new Date(), "dd-MM-yyyy");

  // ── Tiny helper: one print field row ─────────────────────────────────────
  const PF = ({ label, value, full }) => (
    <div className={`print-field${full ? " print-full" : ""}`}>
      <div className="print-label">{label}</div>
      <div className="print-value">{value || ""}</div>
    </div>
  );

  return (
    <>
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton aria-label="close" color="inherit" size="small" onClick={(e) => closeAlert(e)}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      <div className="bg-none nav-wrapper h-100 d-flex flex-column service-view">
        <div className='"d-flex'>
          <IconButton
            aria-label="close"
            onClick={(event) => closeServiceModal(event)}
            sx={{
              position: "absolute", right: 8, top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className="w-100 service-container service-container1" style={{ overflowY: "auto" }}>
          <div className="d-flex m-3 justify-content-between px-4">
            <div className="w-100 flex-wrap flex-column">

              {showError && (
                <div className="text-danger my-4">All fields can not be empty!</div>
              )}

              {/* ════════════════════════════════════════════════════
                  DOCTOR SECTION
              ════════════════════════════════════════════════════ */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <strong>Doctor's Initial Assessment</strong>
                <Button
                  variant="outlined" size="small" startIcon={<PrintIcon />}
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => printSection("print-doctor-section", "Doctor's Initial Assessment")}
                >
                  Print Doctor Section
                </Button>
              </div>

              <Box className="row service-form mb-4" style={{ border: "1px solid #ddd", borderRadius: "6px", padding: "10px 14px" }}>

                <div className="col-12 mb-1"><small><strong>History</strong></small></div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Chief Complaint"]}
                    placeholder="Chief Complaint..." autoComplete="off"
                    onChange={(e) => handleInputChange("Chief Complaint", e.target.value)}
                    label="Pradhana Vedana (Chief Complaint)" multiline minRows={1} maxRows={6} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Present History"]}
                    placeholder="Present History..." autoComplete="off"
                    onChange={(e) => handleInputChange("Present History", e.target.value)}
                    label="Pradhana Vedana Vrittanta (Present History)" multiline minRows={1} maxRows={6} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Past History"]}
                    placeholder="Past History..." autoComplete="off"
                    onChange={(e) => handleInputChange("Past History", e.target.value)}
                    label="Poorva Vyadhi Vrittanta (Past History)" multiline minRows={1} maxRows={6} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Personal History"]}
                    placeholder="Personal History..." autoComplete="off"
                    onChange={(e) => handleInputChange("Personal History", e.target.value)}
                    label="Vayaktika Vrittanta (Personal History)" multiline minRows={1} maxRows={6} />
                </div>

                <div className="col-12 mt-3 mb-1"><small><strong>Personal History Details</strong></small></div>
                {["Appetite", "Micturition", "Bowel", "Sleep"].map((field) => (
                  <div key={field} id="notespadding" className="pl-0 col-lg-3 col-xl-3 col-md-3 col-6 pt-2">
                    <TextField fullWidth className="p-2" value={notes[field]}
                      placeholder={field} autoComplete="off"
                      onChange={(e) => handleInputChange(field, e.target.value)}
                      label={field} />
                  </div>
                ))}

                <div className="col-12 mt-3 mb-1"><small><strong>Family History</strong></small></div>
                <div id="notespadding" className="pl-0 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Family History"]}
                    placeholder="Family History..." autoComplete="off"
                    onChange={(e) => handleInputChange("Family History", e.target.value)}
                    label="Family History" multiline minRows={1} maxRows={6} />
                </div>

                <div className="col-12 mt-3 mb-1"><small><strong>General & Systemic Examination — Vitals</strong></small></div>
                {[["Doctor Temp","Temp"],["Doctor BP","BP"],["Doctor Pulse","Pulse"],["Doctor Height","Height"],["Doctor Weight","Weight"]].map(([key, label]) => (
                  <div key={key} id="notespadding" className="pl-0 col-lg-2 col-xl-2 col-md-3 col-6 pt-2">
                    <TextField fullWidth className="p-2" value={notes[key]}
                      placeholder={label} autoComplete="off"
                      onChange={(e) => handleInputChange(key, e.target.value)}
                      label={label} />
                  </div>
                ))}

                <div id="notespadding" className="pl-0 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["General Systemic Examination"]}
                    placeholder="Examination findings..." autoComplete="off"
                    onChange={(e) => handleInputChange("General Systemic Examination", e.target.value)}
                    label="General & Systemic Examination Notes" multiline minRows={2} maxRows={6} />
                </div>

                <div className="col-12 mt-3 mb-1"><small><strong>Clinical Flags</strong></small></div>

                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                  <label className="service-lable mb-1">Allergies / Adverse Reaction</label>
                  <select className="form-control filterin Quantity"
                    value={notes["Allergies Adverse Reaction"]}
                    onChange={(e) => handleInputChange("Allergies Adverse Reaction", e.target.value)}>
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                {notes["Allergies Adverse Reaction"] === "Yes" && (
                  <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                    <TextField fullWidth className="p-2" value={notes["Allergies Adverse Reaction Details"]}
                      placeholder="Allergy details..." autoComplete="off"
                      onChange={(e) => handleInputChange("Allergies Adverse Reaction Details", e.target.value)}
                      label="If Yes — Allergy Details" multiline minRows={1} maxRows={4} />
                  </div>
                )}

                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                  <label className="service-lable mb-1">Vulnerable Patient</label>
                  <select className="form-control filterin Quantity"
                    value={notes["Vulnerable Patient Doctor"]}
                    onChange={(e) => handleInputChange("Vulnerable Patient Doctor", e.target.value)}>
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="col-12 mt-3 mb-1"><small><strong>Investigations & Treatment</strong></small></div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Lab Investigation"]}
                    placeholder="Lab Investigation..." autoComplete="off"
                    onChange={(e) => handleInputChange("Lab Investigation", e.target.value)}
                    label="Lab Investigation" multiline minRows={2} maxRows={6} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Treatment History"]}
                    placeholder="Treatment History..." autoComplete="off"
                    onChange={(e) => handleInputChange("Treatment History", e.target.value)}
                    label="Chikitsa Vrittanta (Treatment History)" multiline minRows={2} maxRows={6} />
                </div>

                <div id="notespadding" className="pl-0 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Diagnosis"]}
                    placeholder="Diagnosis..." autoComplete="off"
                    onChange={(e) => handleInputChange("Diagnosis", e.target.value)}
                    label="Vyadhi Vinishchaya (Diagnosis)" multiline minRows={2} maxRows={6} />
                </div>

              </Box>

              {/* ── Doctor print content (hidden on screen) ───────────────── */}
              <div id="print-doctor-section" style={{ display: "none" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "12px" }}>
                  <tbody><tr>
                    {[["Patient Name", patientName],["Age/Sex",`${patientAge}/${patientSex}`],["Main",uhid],["Date",todayStr],[ipOpLabel,ipNo]].map(([l,v]) => (
                      <td key={l} style={{ border:"1px solid #bbb", padding:"5px 8px", fontSize:"12px" }}><strong>{l}:</strong> {v}</td>
                    ))}
                  </tr></tbody>
                </table>
                <div className="print-grid">
                  <div className="print-section-title">History</div>
                  <PF label="Pradhana Vedana (Chief Complaint)" value={notes["Chief Complaint"]} full />
                  <PF label="Pradhana Vedana Vrittanta (Present History)" value={notes["Present History"]} full />
                  <PF label="Poorva Vyadhi Vrittanta (Past History)" value={notes["Past History"]} full />
                  <PF label="Vayaktika Vrittanta (Personal History)" value={notes["Personal History"]} full />
                  <div className="print-section-title">Personal History Details</div>
                  {["Appetite","Micturition","Bowel","Sleep"].map(f => <PF key={f} label={f} value={notes[f]} />)}
                  <div className="print-section-title">Family History</div>
                  <PF label="Family History" value={notes["Family History"]} full />
                  <div className="print-section-title">General & Systemic Examination — Vitals</div>
                  {[["Doctor Temp","Temp"],["Doctor BP","BP"],["Doctor Pulse","Pulse"],["Doctor Height","Height"],["Doctor Weight","Weight"]].map(([k,l]) => <PF key={k} label={l} value={notes[k]} />)}
                  <PF label="Examination Notes" value={notes["General Systemic Examination"]} full />
                  <div className="print-section-title">Clinical Flags</div>
                  <PF label="Allergies / Adverse Reaction" value={notes["Allergies Adverse Reaction"]} />
                  <PF label="Allergy Details" value={notes["Allergies Adverse Reaction Details"]} />
                  <PF label="Vulnerable Patient" value={notes["Vulnerable Patient Doctor"]} />
                  <div className="print-section-title">Investigations & Treatment</div>
                  <PF label="Lab Investigation" value={notes["Lab Investigation"]} full />
                  <PF label="Chikitsa Vrittanta (Treatment History)" value={notes["Treatment History"]} full />
                  <PF label="Vyadhi Vinishchaya (Diagnosis)" value={notes["Diagnosis"]} full />
                </div>
              </div>

              {/* ════════════════════════════════════════════════════
                  NURSE SECTION
              ════════════════════════════════════════════════════ */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <strong>Nursing Initial Assessment</strong>
                <Button
                  variant="outlined" size="small" startIcon={<PrintIcon />}
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => printSection("print-nurse-section", "Nursing Initial Assessment")}
                >
                  Print Nurse Section
                </Button>
              </div>

              <Box className="row service-form mb-4" style={{ border: "1px solid #ddd", borderRadius: "6px", padding: "10px 14px" }}>

                <div className="col-12 mb-1"><small><strong>Vitals</strong></small></div>
                {[
                  ["BP","BP"],["Temperature","Temperature"],["Pulse","Pulse"],
                  ["Respiratory Rate","Respiratory Rate"],["Saturation","Saturation (if required)"],
                  ["Height","Height"],["Weight","Weight"],["GRBS","GRBS"],
                ].map(([key, label]) => (
                  <div key={key} id="notespadding" className="pl-0 col-lg-3 col-xl-3 col-md-3 col-6 pt-2">
                    <TextField fullWidth className="p-2" value={notes[key]}
                      placeholder={label} autoComplete="off"
                      onChange={(e) => handleInputChange(key, e.target.value)}
                      label={label} />
                  </div>
                ))}

                <div className="col-12 mt-3 mb-1"><small><strong>Examination</strong></small></div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Level of Consciousness"]}
                    placeholder="Level of Consciousness..." autoComplete="off"
                    onChange={(e) => handleInputChange("Level of Consciousness", e.target.value)}
                    label="Level of Consciousness" multiline minRows={1} maxRows={4} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Respiratory Status"]}
                    placeholder="Respiratory Status..." autoComplete="off"
                    onChange={(e) => handleInputChange("Respiratory Status", e.target.value)}
                    label="Respiratory Status" multiline minRows={1} maxRows={4} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Nurse Chief Complaint"]}
                    placeholder="Present Chief Complaint..." autoComplete="off"
                    onChange={(e) => handleInputChange("Nurse Chief Complaint", e.target.value)}
                    label="Present Chief Complaint" multiline minRows={1} maxRows={4} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Skin Integrity"]}
                    placeholder="Skin Integrity..." autoComplete="off"
                    onChange={(e) => handleInputChange("Skin Integrity", e.target.value)}
                    label="Skin Integrity" multiline minRows={1} maxRows={4} />
                </div>

                <div className="col-12 mt-3 mb-1"><small><strong>Clinical Details</strong></small></div>

                <div id="notespadding" className="pl-0 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Current Medications"]}
                    placeholder="Current Medications..." autoComplete="off"
                    onChange={(e) => handleInputChange("Current Medications", e.target.value)}
                    label="Current Medications" multiline minRows={2} maxRows={6} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Investigation Ordered"]}
                    placeholder="Investigation Ordered..." autoComplete="off"
                    onChange={(e) => handleInputChange("Investigation Ordered", e.target.value)}
                    label="Investigation Ordered" multiline minRows={1} maxRows={4} />
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Diet"]}
                    placeholder="Diet..." autoComplete="off"
                    onChange={(e) => handleInputChange("Diet", e.target.value)}
                    label="Diet" multiline minRows={1} maxRows={4} />
                </div>

                <div className="col-12 mt-3 mb-1"><small><strong>Special Care</strong></small></div>

                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                  <label className="service-lable mb-1">Vulnerable</label>
                  <select className="form-control filterin Quantity"
                    value={notes["Vulnerable Nurse"]}
                    onChange={(e) => handleInputChange("Vulnerable Nurse", e.target.value)}>
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField fullWidth className="p-2" value={notes["Special Care"]}
                    placeholder="Any special care given..." autoComplete="off"
                    onChange={(e) => handleInputChange("Special Care", e.target.value)}
                    label="Any Special Care Given" multiline minRows={1} maxRows={4} />
                </div>

                {/* Pain Scale */}
                <div className="col-12 mt-3 mb-1"><small><strong>Pain Scale</strong></small></div>
                <div className="col-12 pt-2 mb-2">
                  <label className="service-lable mb-2 d-block">
                    Pain Score &nbsp;
                    <span style={{ fontWeight: "normal", fontSize: "12px", color: "#666" }}>
                      (0 = No pain &nbsp; 5 = Moderate &nbsp; 10 = Worst pain)
                    </span>
                  </label>
                  <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                    {[...Array(11).keys()].map((n) => (
                      <button
                        key={n} type="button"
                        onClick={() => handleInputChange("Pain Score", String(n))}
                        style={{
                          width: "36px", height: "36px", border: "1px solid #bbb",
                          borderRadius: "4px", cursor: "pointer",
                          fontWeight: notes["Pain Score"] === String(n) ? "bold" : "normal",
                          background: notes["Pain Score"] === String(n) ? "#1a73e8" : "#fff",
                          color: notes["Pain Score"] === String(n) ? "#fff" : "#333",
                        }}
                      >{n}</button>
                    ))}
                  </div>
                </div>

                {/* Pressure Sores & Restraints */}
                <div className="col-12 mt-3 mb-1"><small><strong>Pressure Sores & Restraints</strong></small></div>

                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                  <label className="service-lable mb-1">Pressure Sores</label>
                  <select className="form-control filterin Quantity"
                    value={notes["Pressure Sores"]}
                    onChange={(e) => handleInputChange("Pressure Sores", e.target.value)}>
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                {notes["Pressure Sores"] === "Yes" && (
                  <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                    <TextField fullWidth className="p-2" value={notes["Pressure Sores Description"]}
                      placeholder="Site, size, description..." autoComplete="off"
                      onChange={(e) => handleInputChange("Pressure Sores Description", e.target.value)}
                      label="Description (site, size, etc.)" multiline minRows={1} maxRows={4} />
                  </div>
                )}

                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                  <label className="service-lable mb-1">Restraints Used</label>
                  <select className="form-control filterin Quantity"
                    value={notes["Restraints Used"]}
                    onChange={(e) => handleInputChange("Restraints Used", e.target.value)}>
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                {notes["Restraints Used"] === "Yes" && (
                  <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                    <TextField fullWidth className="p-2" value={notes["Restraint Description"]}
                      placeholder="Restraint used..." autoComplete="off"
                      onChange={(e) => handleInputChange("Restraint Description", e.target.value)}
                      label="Restraint Description" multiline minRows={1} maxRows={4} />
                  </div>
                )}

                {/* ── Original Comment + Follow Up (100% unchanged) ─────── 
                <div className="col-12 mt-3 mb-1"><small><strong>Additional Notes & Follow Up</strong></small></div>

                <div id="notespadding" className="pl-0  col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                  <TextField
                    fullWidth className="p-2"
                    value={notes["Comment"]}
                    placeholder="Please Type Comment here..."
                    autoComplete="off" type="text"
                    onChange={(event) => { handleInputChange("Comment", event.target.value); }}
                    label={<span>Comment </span>}
                    error={formErrors["Comment"] !== ""}
                    invalid={formErrors["Comment"] === "" ? false : true}
                    multiline minRows={1} maxRows={10}
                  />
                  <div style={{ color: "#EC4147" }}>
                    <span className="service-lable">{formErrors["Comment"]}</span>
                  </div>
                </div>

                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ">
                  <label className="service-lable mb-0">Follow Up Date For Vedamaayu</label>
                  <input
                    name="scheduleddate" id="scheduleddate"
                    className="form-control filterin Quantity"
                    placeholder="Enter ScheduledTime"
                    required type="date"
                    readOnly={followUpDateFlag}
                    min={todayDate}
                    defaultValue={
                      patientDetail["scheduleddate"] === undefined
                        ? revisitDate
                        : patientDetail["scheduleddate"]
                    }
                    onChange={ChangeRevisitDate}
                  />
                </div>*/}

              </Box>

              {/* ── Nurse print content (hidden on screen) ────────────────── */}
              <div id="print-nurse-section" style={{ display: "none" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", marginBottom:"12px" }}>
                  <tbody><tr>
                  {[["Patient Name",patientName],["Age/Sex",`${patientAge}/${patientSex}`],["Main",uhid],[ipOpLabel,ipNo],["Date",todayStr],["Ward",ward]].map(([l,v]) => (
                      <td key={l} style={{ border:"1px solid #bbb", padding:"5px 8px", fontSize:"12px" }}><strong>{l}:</strong> {v}</td>
                    ))}
                  </tr></tbody>
                </table>
                <div className="print-grid">
                  <div className="print-section-title">Vitals</div>
                  {[["BP","BP"],["Temperature","Temperature"],["Pulse","Pulse"],["Respiratory Rate","Respiratory Rate"],["Saturation","Saturation"],["Height","Height"],["Weight","Weight"],["GRBS","GRBS"]].map(([k,l]) => (
                    <PF key={k} label={l} value={notes[k]} />
                  ))}
                  <div className="print-section-title">Examination</div>
                  <PF label="Level of Consciousness" value={notes["Level of Consciousness"]} full />
                  <PF label="Respiratory Status" value={notes["Respiratory Status"]} full />
                  <PF label="Present Chief Complaint" value={notes["Nurse Chief Complaint"]} full />
                  <PF label="Skin Integrity" value={notes["Skin Integrity"]} full />
                  <div className="print-section-title">Clinical Details</div>
                  <PF label="Current Medications" value={notes["Current Medications"]} full />
                  <PF label="Investigation Ordered" value={notes["Investigation Ordered"]} full />
                  <PF label="Diet" value={notes["Diet"]} full />
                  <div className="print-section-title">Special Care</div>
                  <PF label="Vulnerable" value={notes["Vulnerable Nurse"]} />
                  <PF label="Special Care Given" value={notes["Special Care"]} />
                  <div className="print-section-title">Pain Scale</div>
                  <div className="print-full print-field">
                    <div className="print-label">Pain Score</div>
                    <div style={{ display:"flex", gap:"4px", marginTop:"4px" }}>
                      {[...Array(11).keys()].map(n => (
                        <div key={n} style={{
                          width:"26px", height:"26px", border:"1px solid #999",
                          display:"inline-flex", alignItems:"center", justifyContent:"center", fontSize:"11px",
                          background: notes["Pain Score"] === String(n) ? "#333" : "#fff",
                          color: notes["Pain Score"] === String(n) ? "#fff" : "#333",
                        }}>{n}</div>
                      ))}
                    </div>
                  </div>
                  <div className="print-section-title">Pressure Sores & Restraints</div>
                  <PF label="Pressure Sores" value={notes["Pressure Sores"]} />
                  <PF label="Description" value={notes["Pressure Sores Description"]} />
                  <PF label="Restraints Used" value={notes["Restraints Used"]} />
                  <PF label="Restraint Description" value={notes["Restraint Description"]} />
                  <div className="print-section-title">Additional Notes & Follow Up</div>
                  <PF label="Comment" value={notes["Comment"]} full />
                  <PF label="Follow Up Date" value={notes["Follow Up Date For Vedamaayu"]} />
                </div>
              </div>

              {/* ── Save Button (original) ─────────────────────────────── */}
              <div className="d-inline-block text-left my-4 savebutton">
                <Button
                  id="we" type="submit" color="primary" variant="contained"
                  sx={{ textTransform: "capitalize" }}
                  className="btn-primary"
                  onClick={(event) => handleSubmit(event)}
                >
                  Save
                </Button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VedamaayuNotes;
